import "../../stylesheets/new-backoffice.scss";
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.notification-text a').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var notificationDiv = link.closest('.notification');
      var notificationId = notificationDiv.getAttribute('data-notification-id');
      if (!notificationDiv.classList.contains('read')) {
        e.preventDefault();
        fetch(`/backoffice/notifications/set_as_read?id=${notificationId}`, {
          method: 'POST',
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            'Accept': 'application/javascript'
          },
          credentials: 'same-origin'
        }).then(function () {
          window.location = link.href;
        });
      }
    });
  });
  $(".notificationDropMenu").on("click", function (e) {
    e.stopPropagation();
  });

  $(".notificationDropMenu #notifications_view .nav-link").on(
    "click",
    function (e) {
      e.stopPropagation();
      e.preventDefault();
      $("#notifications_view .tab-pane").removeClass("active");
      $("#notifications_view .nav-link").removeClass("active");
      $(this).addClass("active");
      $(`#${$(this).attr("href").split("#")[1]}`).addClass("active");
    }
  );
});
